var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _rect2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGoogleButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 124,
    height: 40,
    viewBox: "0 0 124 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 124,
    height: 40,
    rx: 5,
    fill: "#404040"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.6422 23.5504L22.1011 19.9747L25.6407 16.3803C28.1681 17.7867 30.1087 18.8613 30.4816 19.0584C31.6859 19.712 31.0739 20.5535 30.4816 20.8716C30.3535 20.9359 29.2853 21.5286 27.7005 22.4079L27.6996 22.4084L27.6992 22.4087L27.6978 22.4094C27.4424 22.5512 27.1735 22.7004 26.8931 22.8562C26.4976 23.0758 26.079 23.3082 25.6422 23.5504ZM24.9974 23.9079L21.6031 20.4805L10.2605 31.9991C10.3971 31.9576 10.542 31.8946 10.6968 31.8088L11.5324 31.3479C13.865 30.0614 20.2774 26.5248 24.9974 23.9079ZM9.33347 31.9291C9.0005 31.7026 8.82617 31.2289 8.82617 30.6306V9.41045C8.82617 8.74961 9.05672 8.34275 9.37614 8.1339L21.1037 19.9761L9.33347 31.9291ZM10.2433 8.00098L21.6017 19.4704L24.9842 16.0354C22.8878 14.8809 11.4539 8.58476 10.6966 8.17806C10.5521 8.09135 10.3981 8.03313 10.2433 8.00098Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M83.9531 13.3181L88.1851 13.3181C88.1851 13.3181 90.6213 13.7311 90.6213 16.5187C90.6213 19.3062 88.1851 19.7192 88.1851 19.7192L83.9531 19.7192V13.3181ZM84.7742 14.8665V18.3016H87.6471C87.6471 18.3016 88.9545 18.3016 88.9545 16.584C88.9545 14.8665 87.6471 14.8665 87.6471 14.8665H84.7742Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M85.073 13.3181H83.5801V23.7313H85.073V13.3181Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M92.9851 13.3181H91.4922V23.7313H92.9851V13.3181Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M98.5186 22.9873C98.1074 23.3253 97.45 23.6435 96.4117 23.7081C94.0329 23.8562 94.0317 21.6933 94.0317 21.5474C94.0317 21.4015 93.9144 19.6377 95.8066 19.3573C97.1465 19.1588 98.0849 19.4896 98.5186 19.6996V19.3936C98.4123 18.9884 98.0822 18.2439 97.0928 18.2439C95.7334 18.2439 95.4332 18.9762 95.4332 18.9762L94.1896 18.2439C94.1896 18.2439 94.8855 16.8145 96.9735 16.8145C99.5697 16.8145 100.012 18.5988 100.012 19.1997C100.012 19.2027 100.012 19.2056 100.012 19.2085V23.7285H98.5186V22.9873ZM98.412 20.7568C98.412 20.7568 95.5358 19.9844 95.4359 21.5944C95.3359 23.2044 98.1951 22.4313 98.4506 21.29C98.4506 20.927 98.412 20.7568 98.412 20.7568Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M102.813 23.3362L100.151 17.0371H101.644L103.559 21.5696L105.459 17.0731H106.952L102.913 26.6322H101.42L102.813 23.3362Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M80.2377 19.4717L75.516 21.4161C75.516 21.4161 75.8209 22.4916 77.2405 22.4988C78.3521 22.5044 78.9796 21.517 78.9796 21.517L80.1776 22.3254C80.1776 22.3254 79.2109 23.8833 77.2311 23.8833C74.7981 23.8833 73.7266 21.7635 73.7266 20.3868C73.7266 19.0604 74.5771 16.8145 77.0801 16.8145C79.5831 16.8145 80.2377 19.4717 80.2377 19.4717ZM78.4412 18.9209C78.4412 18.9209 77.8471 18.0203 76.936 18.1864C75.0088 18.5377 75.2513 20.2182 75.2513 20.2182L78.4412 18.9209Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M73.0667 13.3181H71.4873V23.7095H73.0667V13.3181Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.9588 17.0403L70.4189 17.0529V23.6095C70.4189 25.2847 69.4179 27.053 67.0615 27.053C64.705 27.053 63.9439 24.9726 63.9439 24.9726L65.2849 24.4107C65.2849 24.4107 65.6938 25.6928 67.1311 25.6928C68.7679 25.6928 68.959 24.2091 68.959 23.7012V22.9896C68.959 22.9896 68.3927 23.8728 66.986 23.8728C65.4608 23.8728 63.6484 22.5708 63.6484 20.3511C63.6484 18.1314 65.355 16.8617 67.0036 16.8156C68.3241 16.7786 68.9588 17.6888 68.9588 17.6888V17.0403ZM67.1106 22.5404C68.1753 22.5404 69.0385 21.5686 69.0385 20.3698C69.0385 19.171 68.1753 18.1992 67.1106 18.1992C66.0459 18.1992 65.1828 19.171 65.1828 20.3698C65.1828 21.5686 66.0459 22.5404 67.1106 22.5404Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.4395 23.8806C57.4768 23.8806 55.8857 22.2988 55.8857 20.3475C55.8857 18.3963 57.4768 16.8145 59.4395 16.8145C61.4022 16.8145 62.9932 18.3963 62.9932 20.3475C62.9932 22.2988 61.4022 23.8806 59.4395 23.8806ZM59.4163 22.4951C60.5195 22.4951 61.4138 21.5336 61.4138 20.3475C61.4138 19.1615 60.5195 18.2 59.4163 18.2C58.3131 18.2 57.4187 19.1615 57.4187 20.3475C57.4187 21.5336 58.3131 22.4951 59.4163 22.4951Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.751 23.8806C49.7883 23.8806 48.1973 22.2988 48.1973 20.3475C48.1973 18.3963 49.7883 16.8145 51.751 16.8145C53.7137 16.8145 55.3047 18.3963 55.3047 20.3475C55.3047 22.2988 53.7137 23.8806 51.751 23.8806ZM51.7278 22.4951C52.831 22.4951 53.7253 21.5336 53.7253 20.3475C53.7253 19.1615 52.831 18.2 51.7278 18.2C50.6246 18.2 49.7303 19.1615 49.7303 20.3475C49.7303 21.5336 50.6246 22.4951 51.7278 22.4951Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.5742 17.9346H47.2661L47.2196 19.4125H42.5742V17.9346Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.3431 14.4568L45.2694 15.5242C44.5998 14.8435 43.6487 14.4704 42.5513 14.4704C40.3577 14.4704 38.5794 16.2383 38.5794 18.4191C38.5794 20.5999 40.3577 22.3678 42.5513 22.3678C44.7448 22.3678 46.3023 21.107 46.299 18.4191C46.3027 18.253 46.2988 18.0913 46.2876 17.9341H47.6582C47.6583 17.9524 47.6584 17.9707 47.6584 17.9891C48.1739 21.7525 45.5958 23.9195 42.5048 23.8918C39.4646 23.8875 37 21.4416 37 18.4191C37 15.3965 39.4646 12.9463 42.5048 12.9463C44.094 12.9463 45.4299 13.4983 46.3431 14.4568Z",
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 123,
    height: 39,
    rx: 4.5,
    stroke: "url(#paint0_linear_7562_1981)",
    strokeOpacity: 0.1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleButton);
export default __webpack_public_path__ + "static/media/GoogleButton.ca3e108c0bf9813ecfa349491b276fe6.svg";
export { ForwardRef as ReactComponent };